import { useTypedSelector } from "./useTypedSelector";

export const useIsUserStatusActive = (): boolean =>
  useTypedSelector(state => state.user.data?.status) === "active";
